var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container-pay", style: _vm.cssVars() },
    [
      _c(
        "div",
        {
          staticClass: "custom-nav-block",
          style: `paddingTop: ${_vm.barHeight}px; backgroundColor: #F9F9FB`,
        },
        [
          _c("van-nav-bar", {
            staticClass: "van-bar",
            attrs: { "left-trangle": "" },
            on: { "click-left": _vm.goBack },
            scopedSlots: _vm._u([
              {
                key: "left",
                fn: function () {
                  return [
                    _c("img", {
                      staticClass: "left-nav",
                      attrs: {
                        src: require("@/assets/packageAssets/common/arrow01.png"),
                        alt: "",
                      },
                    }),
                    _c("span", { staticClass: "tit-left" }, [
                      _vm._v(_vm._s(_vm.$t("lang.commonM.k368"))),
                    ]),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "main" },
        [
          _c("div", { staticClass: "pay" }, [
            _c("div", { staticClass: "money-block" }, [
              _c("img", {
                staticClass: "moneys",
                attrs: { src: _vm.getMatchImg("coin"), alt: "" },
              }),
              _c("div", { staticClass: "amount" }, [
                _vm._v(_vm._s(_vm.myPlus(_vm.amount, _vm.presentAmount))),
              ]),
              _vm.presentAmount > 0
                ? _c("div", { staticClass: "origin-amount" }, [
                    _c("div", { staticClass: "old-amount" }, [
                      _vm._v(_vm._s(_vm.amount)),
                    ]),
                    _c("div", { staticClass: "extra-amount" }, [
                      _vm._v("+" + _vm._s(_vm.presentAmount)),
                    ]),
                  ])
                : _vm._e(),
            ]),
            _c(
              "div",
              { staticClass: "pay-other" },
              [
                _vm._l(_vm.presentPropList, function (item, index) {
                  return [
                    item.propType == 1
                      ? _c("div", { staticClass: "dis-item" }, [
                          _c("img", {
                            attrs: { src: _vm.getMatchImg("chat-pass") },
                          }),
                          _vm._v(" x" + _vm._s(item.number) + " "),
                        ])
                      : item.propType == 2
                      ? _c("div", { staticClass: "dis-item" }, [
                          _c("img", {
                            attrs: { src: _vm.getMatchImg("video-pass") },
                          }),
                          _vm._v(" x" + _vm._s(item.number) + " "),
                        ])
                      : item.propType == 4
                      ? _c("div", { staticClass: "dis-item" }, [
                          _c("img", { attrs: { src: _vm.getMatchImg("vip") } }),
                          _vm._v(" x" + _vm._s(item.number) + " "),
                        ])
                      : item.propType == 6
                      ? _c("div", { staticClass: "dis-item" }, [
                          _c("img", {
                            attrs: { src: _vm.getMatchImg("call-pass") },
                          }),
                          _vm._v(" x" + _vm._s(item.number) + " "),
                        ])
                      : item.propType == 9
                      ? _c("div", { staticClass: "dis-item" }, [
                          _c("img", {
                            attrs: { src: _vm.getMatchImg("coupon") },
                          }),
                          _vm._v(" x" + _vm._s(item.number) + " "),
                        ])
                      : item.propType == 15
                      ? _c("div", { staticClass: "dis-item" }, [
                          _c("img", {
                            attrs: { src: _vm.getMatchImg("super-chat-pass") },
                          }),
                          _vm._v(" x" + _vm._s(item.number) + " "),
                        ])
                      : _vm._e(),
                  ]
                }),
              ],
              2
            ),
            _c("div", { staticClass: "tips-one" }, [
              _vm._v(_vm._s(_vm.$t("lang.commonM.k369"))),
            ]),
          ]),
          _c("div", { staticClass: "block-title" }, [
            _c("div", [_vm._v(_vm._s(_vm.$t("lang.commonM.k370")))]),
            _c("div", { staticClass: "looping-container" }, [
              _c("div", { staticClass: "looping-text" }, [
                _vm._v(_vm._s(_vm.$t("lang.commonM.k387"))),
              ]),
            ]),
          ]),
          _c("div", { staticClass: "coupons-block" }, [
            _c(
              "div",
              {
                staticClass: "coupon-item",
                on: { click: _vm.handleClickCouponEnter },
              },
              [
                _vm.selectedCoupon
                  ? [
                      _c("div", { staticClass: "coupon-check checked" }),
                      _c("div", { staticClass: "coupon-con" }, [
                        _c("img", {
                          staticClass: "coupon",
                          attrs: { src: _vm.getMatchImg("coupon") },
                        }),
                        _c(
                          "div",
                          { staticClass: "coupon-info" },
                          [
                            _c("MyPLabel", {
                              staticClass: "info-main",
                              attrs: {
                                str: _vm.selectedCoupon.descV2,
                                customClass: { coin: "pay-coin-icon" },
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                    ]
                  : [
                      _c("div", { staticClass: "coupon-check not-checked" }),
                      _c("div", { staticClass: "coupon-con no-valid-coupon" }, [
                        _c("img", {
                          staticClass: "coupon",
                          attrs: { src: _vm.getMatchImg("coupon-off") },
                        }),
                        _c("div", { staticClass: "coupon-info" }, [
                          _c("span", { staticClass: "info-main" }, [
                            _vm._v(_vm._s(_vm.$t("lang.intimate.noValidCou"))),
                          ]),
                        ]),
                      ]),
                    ],
                _vm.validCouponList && _vm.validCouponList.length
                  ? _c("div", {
                      staticClass: "coupon-arrow",
                      class: [_vm.showCoupons ? "arrow-up" : ""],
                    })
                  : _vm._e(),
              ],
              2
            ),
            _vm.showCoupons
              ? _c(
                  "div",
                  { staticClass: "coupon-scroll" },
                  _vm._l(_vm.validCouponList, function (item, index) {
                    return _c(
                      "div",
                      {
                        key: item.couponRecordId,
                        staticClass: "coupon-item",
                        on: {
                          click: function ($event) {
                            return _vm.handleSelectCoupon(item)
                          },
                        },
                      },
                      [
                        _vm.selectedCoupon &&
                        item.couponRecordId ===
                          _vm.selectedCoupon.couponRecordId
                          ? _c("div", { staticClass: "coupon-check checked" })
                          : _c("div", {
                              staticClass: "coupon-check not-checked",
                            }),
                        item.canUse === true
                          ? _c("div", { staticClass: "coupon-con" }, [
                              _c("img", {
                                staticClass: "coupon",
                                attrs: { src: _vm.getMatchImg("coupon") },
                              }),
                              _c(
                                "div",
                                { staticClass: "coupon-info" },
                                [
                                  _c("MyPLabel", {
                                    staticClass: "info-main",
                                    attrs: {
                                      str: item.descV2,
                                      customClass: { coin: "pay-coin-icon" },
                                    },
                                  }),
                                ],
                                1
                              ),
                            ])
                          : _c(
                              "div",
                              { staticClass: "coupon-con no-valid-coupon" },
                              [
                                _c("img", {
                                  staticClass: "coupon",
                                  attrs: { src: _vm.getMatchImg("coupon-off") },
                                }),
                                _c(
                                  "div",
                                  { staticClass: "coupon-info" },
                                  [
                                    _c("MyPLabel", {
                                      staticClass: "info-main",
                                      attrs: {
                                        str: item.descV2,
                                        customClass: { coin: "pay-coin-icon" },
                                      },
                                    }),
                                    _c("span", { staticClass: "info-tips" }, [
                                      _vm._v("This item is not supported"),
                                    ]),
                                  ],
                                  1
                                ),
                              ]
                            ),
                      ]
                    )
                  }),
                  0
                )
              : _vm._e(),
          ]),
          _c("div", { staticClass: "block-title" }, [
            _c("div", [_vm._v(_vm._s(_vm.$t("lang.commonM.k371")))]),
          ]),
          _vm._l(_vm.payList, function (item, index) {
            return [
              index <= _vm.beforeOriginPayIndex &&
              item.priority <= _vm.currentPayTypeLevel
                ? _c(
                    "div",
                    {
                      key: index,
                      class: [
                        "method-item",
                        item.ifBestPrice === true ? "best-type" : "",
                        index === _vm.selectedIndex ? "method-on" : "",
                      ],
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.handleSelectPay(item, index)
                        },
                      },
                    },
                    [
                      _c("div", { staticClass: "method-con" }, [
                        _c("div", {
                          staticClass: "method-check",
                          class: [
                            index === _vm.selectedIndex
                              ? "checked"
                              : "not-checked",
                          ],
                        }),
                        _c("div", { staticClass: "method-img" }, [
                          _c("img", {
                            attrs: {
                              src: _vm._f("imgPath")(item.icon),
                              alt: "",
                            },
                          }),
                        ]),
                        item.icon
                          ? _c("div", { staticClass: "method-name" }, [
                              _c("div", { staticClass: "method-info" }, [
                                _c("span", { staticClass: "name" }, [
                                  _vm._v(_vm._s(item.name)),
                                ]),
                                _vm._v("   "),
                                item.label
                                  ? _c("div", { staticClass: "discount" }, [
                                      _vm._v(_vm._s(item.label)),
                                    ])
                                  : _vm._e(),
                              ]),
                              _c("div", { staticClass: "rate" }, [
                                _vm._v(
                                  _vm._s(item.currency) +
                                    " " +
                                    _vm._s(_vm.handleDiv100(item.price))
                                ),
                              ]),
                            ])
                          : _vm._e(),
                      ]),
                      item.ifBestPrice === true
                        ? _c("MyPLabel", {
                            staticClass: "method-tips",
                            attrs: {
                              str: _vm.$t("lang.commonM.k385"),
                              customClass: { coin: "pay-coin-icon" },
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
            ]
          }),
          _vm.googlePrice
            ? _c(
                "div",
                {
                  class: [
                    "method-item",
                    _vm.selectedIndex === 9999 ? "method-on" : "",
                  ],
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      _vm.handleSelectPay(
                        {
                          currency: _vm.googleCurrency,
                          price: _vm.myTimes(_vm.googlePrice, 100),
                          currencyPrice: _vm.googleCurrencyCurrency,
                        },
                        9999
                      )
                    },
                  },
                },
                [
                  _c("div", { staticClass: "method-con" }, [
                    _c("div", {
                      staticClass: "method-check",
                      class: [
                        _vm.selectedIndex === 9999 ? "checked" : "not-checked",
                      ],
                    }),
                    _c("div", { staticClass: "method-img" }, [
                      _vm.env.isIOS
                        ? _c("img", {
                            attrs: {
                              src: require("@/assets/packageAssets/common/apple_pay.png"),
                              alt: "",
                            },
                          })
                        : _c("img", {
                            attrs: {
                              src: require("@/assets/packageAssets/common/google.png"),
                              alt: "",
                            },
                          }),
                    ]),
                    _c("div", { staticClass: "method-name" }, [
                      _c("div", { staticClass: "method-info" }, [
                        _c("span", { staticClass: "name" }, [
                          _vm._v(
                            _vm._s(_vm.env.isIOS ? "Apple Pay" : "Google Pay")
                          ),
                        ]),
                      ]),
                      _vm.googleCurrencyCurrency
                        ? _c("div", { staticClass: "rate" }, [
                            _vm._v(_vm._s(_vm.googleCurrencyCurrency)),
                          ])
                        : _c("div", { staticClass: "rate" }, [
                            _vm._v(
                              _vm._s(_vm.googleCurrency) +
                                " " +
                                _vm._s(_vm.googlePrice)
                            ),
                          ]),
                    ]),
                  ]),
                ]
              )
            : _vm._e(),
          _vm._l(_vm.payList, function (item, index) {
            return [
              index > _vm.beforeOriginPayIndex &&
              item.priority <= _vm.currentPayTypeLevel
                ? _c(
                    "div",
                    {
                      key: index,
                      class: [
                        "method-item",
                        item.ifBestPrice === true ? "best-type" : "",
                        index === _vm.selectedIndex ? "method-on" : "",
                      ],
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.handleSelectPay(item, index)
                        },
                      },
                    },
                    [
                      _c("div", { staticClass: "method-con" }, [
                        _c("div", {
                          staticClass: "method-check",
                          class: [
                            index === _vm.selectedIndex
                              ? "checked"
                              : "not-checked",
                          ],
                        }),
                        _c("div", { staticClass: "method-img" }, [
                          _c("img", {
                            attrs: {
                              src: _vm._f("imgPath")(item.icon),
                              alt: "",
                            },
                          }),
                        ]),
                        item.icon
                          ? _c("div", { staticClass: "method-name" }, [
                              _c("div", { staticClass: "method-info" }, [
                                _c("span", { staticClass: "name" }, [
                                  _vm._v(_vm._s(item.name)),
                                ]),
                                _vm._v("   "),
                                item.label
                                  ? _c("div", { staticClass: "discount" }, [
                                      _vm._v(_vm._s(item.label)),
                                    ])
                                  : _vm._e(),
                              ]),
                              _c("div", { staticClass: "rate" }, [
                                _vm._v(
                                  _vm._s(item.currency) +
                                    " " +
                                    _vm._s(_vm.handleDiv100(item.price))
                                ),
                              ]),
                            ])
                          : _vm._e(),
                      ]),
                      item.ifBestPrice === true
                        ? _c("MyPLabel", {
                            staticClass: "method-tips",
                            attrs: {
                              str: _vm.$t("lang.commonM.k385"),
                              customClass: { coin: "pay-coin-icon" },
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
            ]
          }),
          _vm.showMore
            ? _c("div", { staticClass: "method-more" }, [
                _c("div", {
                  staticClass: "trangle",
                  class: {
                    "trangle-down":
                      _vm.currentPayTypeLevel !== _vm.lastPayTypeLevel,
                  },
                  on: { click: _vm.showMorePay },
                }),
              ])
            : _vm._e(),
          _c("div", { staticStyle: { width: "100%", height: "100px" } }),
          _c("div", { staticClass: "submit-btn-block" }, [
            _c(
              "div",
              { staticClass: "submit-btn", on: { click: _vm.handleClickPay } },
              [
                _vm._v(
                  " " +
                    _vm._s(_vm.$t("lang.host.get")) +
                    " " +
                    _vm._s(_vm.myPlus(_vm.amount, _vm.presentAmount)) +
                    " "
                ),
                _c("img", { attrs: { src: _vm.getMatchImg("coin") } }),
                _vm.selectedItem
                  ? [
                      _vm.selectedItem.currencyPrice
                        ? [
                            _vm._v(
                              "(" + _vm._s(_vm.selectedItem.currencyPrice) + ")"
                            ),
                          ]
                        : [
                            _vm._v(
                              "(" +
                                _vm._s(_vm.selectedItem.currency) +
                                " " +
                                _vm._s(
                                  _vm.handleDiv100(_vm.selectedItem.price)
                                ) +
                                ")"
                            ),
                          ],
                    ]
                  : _vm._e(),
                _vm.loadingShow
                  ? _c("van-loading", {
                      staticClass: "pay-loading",
                      attrs: {
                        type: "spinner",
                        color: "#ffffff",
                        size: "20px",
                      },
                    })
                  : _vm._e(),
              ],
              2
            ),
            _c("div", { style: { height: `${_vm.bottomBarHeight || 30}px` } }),
          ]),
        ],
        2
      ),
      _c("PayResult", {
        attrs: {
          showDiaC: _vm.showResultDia,
          oneShow: true,
          title: _vm.payResultText,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }